<div *ngFor="let entity of d | async; let i = index">
  <flx-entity-card
    [data$]="entity"
    (click)="entitySelected(entity)"
    [state]="state"
  ></flx-entity-card>
</div>
